<template>
    <div class="bg">
        <div class="wrap">
            <div class="info-wrap">
                <div class="item-wrap indent">
                    <span class="title">{{title_1}}</span>
                    <div class="item">
                        <span>诊断</span>
                        <input type="text" v-model="data.res_check" readonly @click="check">
                        <label></label>
                    </div>
                    <div class="item" v-if="data.res_check!='T2DM'" >
                        <span>并发症</span>
                        <input type="text" v-model="data.res_complication">
                    </div>
                    <div class="item">
                        <span>建议</span>
                        <input type="text" v-model="data.res_suggestion" readonly @click="suggestion">
                        <label></label>
                    </div>
                </div>

                <div class="item-wrap">
                    <span class="title indent">{{title_2}}</span>
                    <div class="file-wrap">
                        <div class="file-item">
                            <img id="img1" class="img" src="../../assets/img/plus.png">
                            <input class="file" type="file" accept="image/*" multiple="multiple" @change="fileChange_1" ref="file_1">
<!--                            <input class="change" accept="image/*" type="file" multiple="multiple"  @change="fileChange_1" ref="file_1"/>-->
                            <span class="hint">请选择病例</span>
                        </div>
                        <div class="file-item">
                            <img id="img2" class="img" src="../../assets/img/plus.png">
                            <input class="file" type="file" accept="image/*" multiple="multiple" @change="fileChange_2" ref="file_2">
<!--                            <input class="change" accept="image/*" type="file"  multiple="multiple" @change="fileChange_2" ref="file_2">-->
                            <span class="hint">请选择凭证</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="next">
                <span @click="toNext">{{next}}</span>
            </div>

            <mt-popup class="popup" v-model="popupVisible" popup-transition="popup-fade" closeOnClickModal="true" position="bottom">
                <mt-picker :slots="slots" @change="slotValueChange" showToolbar>
                    <div class="picker-toolbar-title">
                        <div class="usi-btn-cancel" @click="popupVisible = !popupVisible">取消</div>
                        <div class="">请选择</div>
                        <div class="usi-btn-sure" @click="slotValueAdd">确定</div>
                    </div>
                </mt-picker>
            </mt-popup>

        </div>
    </div>
</template>

<script>
import {getUuid} from "@/assets/util/util";
import {getOssSecret} from "@/assets/js/api";
import OSS from 'ali-oss';
import { Indicator } from 'mint-ui';
import {addCase,getCase} from "@/assets/js/api";

export default {
  name: 'HelloWorld',
  data(){
    return{
        title_1:"6、诊断及治疗建议",
        title_2:"8、病例有效性",
        title_3:"7、方案",
        next:"下一步 >",
        data:{
           res_check:"",
           res_complication:"",
           res_suggestion:"",
           res_img_1:"",
           res_img_2:"",
           caseId:this.$store.state.caseId,
           docId:this.$store.state.docId,
        },
        slots: [
            {
                values: [],
            }
        ],
        slotSure:"",
        slotTag:0,
        popupVisible:false,
        ossKeySecret:'',
        ossPrefix:"talk/solicitation/",
        img1Select:false,
        img2Select:false,
        editStation:0
    }
  },
    mounted(){
        this.getSecret();
        this.getCase(this.data.caseId)
    },
    methods:{
      async getCase(caseId){
          let res = await getCase({caseId})
          this.data.res_check = res.data.data.res_check==null?"":res.data.data.res_check
          this.data.res_suggestion = res.data.data.res_suggestion==null?"":res.data.data.res_suggestion
          this.data.res_complication = res.data.data.res_complication==null?"":res.data.data.res_complication
          console.log(res,"res")

          if(res.data.data.res_img_1!=null){
              document.getElementById("img1").src = res.data.data.res_img_1
              this.data.res_img_1 =  res.data.data.res_img_1
          }
          if(res.data.data.res_img_2!=null){
              document.getElementById("img2").src = res.data.data.res_img_2
              this.data.res_img_2 =  res.data.data.res_img_2
          }

          this.editStation = res.data.data.sys_station

      },
       toNext(){

           if(this.editStation==1){ //审核通过的
               this.toCase();//回到首页
               return
           }

          if(this.data.res_check==""){
              this.$toast("请选择诊断");
              return
          }

          if(this.data.res_check!="T2DM"&&this.data.res_complication==""){
              this.$toast("请填写并发症");
              return
          }

          if(this.data.res_suggestion==""){
              this.$toast("请选择建议");
              return
          }

          if(!this.img1Select&&this.data.res_img_1==""){
              this.$toast("请选择病例");
              return
          }

          if(!this.img2Select&&this.data.res_img_1==""){
              this.$toast("请选择凭证");
              return
          }


          Indicator.open({
              text: '上传中',
              spinnerType: 'fading-circle'
          });

           /**
            *  input 1 有
            *  input 2有
            *  input 1没有
            *  input 2 没有
            */
           let _this = this
           if(_this.img1Select){ //1,有
               console.log("1有")
               _this.ossUpload(_this.$refs.file_1.files[0]).then(function (res) {
                   // console.log(res,"img1")
                   _this.data.res_img_1 = res
                   if (_this.img2Select){//2,有
                       console.log("2有")
                       _this.ossUpload(_this.$refs.file_2.files[0]).then(function (res) {
                           console.log(res,"img2")
                           _this.data.res_img_2 = res
                           Indicator.close();
                           _this.addCaseData();
                       })
                   }else{
                       Indicator.close();
                       console.log("2没有")
                       _this.addCaseData();
                   }
               })
           }else {//1没有
               console.log("1没有")
               if (_this.img2Select){//2,有
                   _this.ossUpload(_this.$refs.file_2.files[0]).then(function (res) {
                       console.log("2有")
                       _this.data.res_img_2 = res
                       Indicator.close();

                       _this.addCaseData();
                   })
               }else{
                   Indicator.close();
                   console.log("2没有")
                   _this.addCaseData();
               }
           }
      },

       async addCaseData(){
           let data = this.data
           let caseRes =  await addCase({data})
           console.log(caseRes.data,"caseRes")
           if(caseRes.data.success ==true){
               Indicator.close();
               this.$toast("提交成功")
               this.toCase();//进入下一步
           }else {
               this.$toast(caseRes.data.message)
           }
       } ,

      toCase(){
          this.$router.push({path:"case",query:{scheme:this.$route.query.scheme}})
      },
        check(){
            this.popupVisible =true
            this.slots[0].values = ['T2DM','　T2DM合并并发症']
            this.slotTag=1
        },
        suggestion(){
            this.popupVisible =true
            this.slots[0].values = ['西格列他钠字样32mg.QD.PO 自备','西格列他钠字样48mg.QD.PO 自备']
            this.slotTag=2
        },
        slotValueChange(picker, values){
            this.slotSure = values[0];
        },
        slotValueAdd(){
            this.popupVisible = !this.popupVisible
            switch (this.slotTag) {
                case 1:
                    this.data.res_check = this.slotSure;
                    break;
                case 2:
                    this.data.res_suggestion = this.slotSure;
                    break;
            }
        },
        fileChange_1(event){
            let fr = new FileReader();
            fr.readAsDataURL(event.target.files[0]);
            let _this = this
            fr.onload = function (e) {
                document.getElementById('img1').src = e.target.result;
                // _this.data.res_img_1 = event.target.files[0].name
                _this.img1Select = true
            };
        },
        fileChange_2(event){
            let fr = new FileReader();
            fr.readAsDataURL(event.target.files[0]);
            let _this = this
            fr.onload = function (e) {
                document.getElementById('img2').src = e.target.result;
                // _this.data.res_img_2 = event.target.files[0].name
                _this.img2Select = true
            };
        },
        async getSecret(){
            const res = await getOssSecret();
            console.log(res,"secret res")
            if(res.data.success==true){
                this.ossKeySecret = res.data.data.accessKeySecret;
            }
        },

        async ossUpload(file){

            let client = new OSS({
                region: 'oss-cn-beijing',
                accessKeyId: 'LTAINtmi5XZ7NaV5',
                accessKeySecret: this.ossKeySecret,
                bucket: 'ymd-lcc'
            })

            let uuid = getUuid()
            uuid+=("."+file.name.split(".")[1])
            let key = this.ossPrefix + uuid

            let link=""

            await client.put(key, file).then(function (res) {

                let str = res.res.requestUrls[0]
                let status = res.res.status
                if(status == 200){
                    const workLink =  str.split("?")[0];
                    link = workLink
                }else {
                    this.$toast("上传失败")
                }
            }).catch((err) => {
                // Indicator.close();
                console.log(err,"异常啦")
                this.$toast("无法获取视频，请更换手机重试")
            })

            return link
        },

    },
}
</script>

<style scoped lang="scss">

    .bg{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
    }

    .wrap{
        width: 100%;
        max-width: 400px;
        height: 100vh;
        background: #FFF;
    }

    .item-wrap{
        width: 95%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: start;
        font-size: 20px;
        text-align: left;
        /*text-indent: 10px;*/
        .title{
            width: 100%;
            background: #0082C5;
            color: #FFF;
            font-size: 22px;
            border-radius: 5px;
            margin-top: 20px;
            padding: 5px 0;
        }
        .item {
            width: 100%;
            background: #D0E6F4;
            line-height: 20px;
            font-size: 18px;
            padding: 4px 0;
            margin-top: 10px;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
                width: 18%;
                color: #999;
            }
        }
    }

    input {
        border: 0;
        background: transparent;
        flex-grow: 1;
        height: 30px;
        text-indent: 10px;
        font-size: 18px;
        outline: none;
    }

    label {
        width: 10px;
        height: 10px;
        border-top: 1px solid #999;;
        border-right: 1px solid #999;
        transform: rotate(45deg);
        margin-right: 10px;
    }


    .info-wrap {
        width: 100%;
        height: 90%;
        overflow: scroll;
    }

    .next{
        height: 10%;
        color: #0082C5;
        font-size: 20px;
        margin-right: 30px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }


    .popup{
        width: 100%;
    }

    .picker-toolbar-title {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
    }

    .usi-btn-cancel,
    .usi-btn-sure {
        color: #0082C5;
    }

    .file-wrap{
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        justify-content: space-around;
    }

    .file-item{
        width: 45%;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
    }

    img {
        width: 100%;
        height: 200px;
        margin: 0;
        padding: 0;
        object-fit: contain;
    }

    .file{
        width: 100%;
        height: 200px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }

    .indent{
        text-indent: 10px;
    }

    .hint{
        margin-top: 10px;
        align-items: center;
    }

    label {
        width: 10px;
        height: 10px;
        border-top: 1px solid #999;;
        border-right: 1px solid #999;
        transform: rotate(45deg);
        margin-right: 10px;
    }

    .mint-indicator-wrapper {
        z-index: 1000 !important;
    }

    .mint-indicator-mask {
        z-index: 1000 !important;
    }

</style>
